import * as React from "react";

import { cn } from "@/lib/utils";

const inputClassName =
  "flex h-10 w-full rounded-[8px] border-[1.5px] border-border bg-background px-3 py-2 text-base text-foreground shadow-[0_1px_0_rgba(255,255,255,0.92)_inset,0_0_0_0.5px_rgba(0,0,0,0.03),0_2px_8px_rgba(0,0,0,0.03)] dark:shadow-[0_1px_0_rgba(255,255,255,0.04)_inset,0_2px_8px_rgba(0,0,0,0.12)] transition-[border-color,box-shadow,background-color] duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-v-gray-300 focus-visible:border-theme-blue/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-blue/20 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputClassName, className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input, inputClassName };
